import { MessageGroup } from '../types';

import { MessageBlock } from './Message';

export const ChatBubble = ({ group }: { group: MessageGroup }) => {
  return (
    <div>
      <p className="mb-1.5 pe-2.5 text-xs text-muted-foreground">
        {group.user.username}
      </p>
      <div className="space-y-1">
        {group.messages.map((message) => (
          <MessageBlock
            key={message.id}
            isUserMessage={group.isUserMessage}
            message={message}
          />
        ))}
      </div>
    </div>
  );
};
